<div *ngIf="!hidden" class="solid-line"></div>
<div class="article" *ngIf="articleLine.quantity> 0">
  <div class="article-data">
    <div class="item-iconwrapper">
      <ion-icon name="alberta-article"></ion-icon>
    </div>
    <div class="description">
      <div class="articleName bold">
        {{ articleLine?.articleName }}
      </div>
      <div class="quantity">
        {{ articleLine?.quantity }} {{ articleLine?.packagingUnit?.unit | articleUnitPipe }} ({{
        articleLine?.packagingUnit?.quantity }} {{ 'order.edit.unit' | translate }})
      </div>
      <div class="cards-container">
        <itl-card [header]="'directOrder.price' | translate">
          {{ articleLine.price ? articleLine.price : '0,00' }} €
        </itl-card>
        <itl-card [header]="'order.edit.customerNumber' | translate">
          {{ articleLine?.articleCustomerNumber }}
        </itl-card>
      </div>
      <div class="check">
        <itl-checkbox
          [(ngModel)]="articleLine.ordered"
          [title]="'crossTherapy.document.billingSummary.orderArticles'|translate"
          noIcon="true"
        ></itl-checkbox>
      </div>
    </div>
  </div>
  <div class="article-summary">
    <div class="frame">
      <ion-input [(ngModel)]="articleLine.totalPrice" (ngModelChange)="updatePrice()"> </ion-input>
      <div class="currency">€</div>
    </div>
  </div>
</div>
